import { mapParse5CodeToDiagnosticCode as e, resolveCatalogMessage as t } from "./catalog.js";
import { parse as n } from "acorn";
import { parse as r } from "css-tree";
import { parseFragment as i } from "parse5";
//#region src/tracking-code-input/validation/run-built-in-validation.ts
var a = /* @__PURE__ */ new Set([
	"text/javascript",
	"application/javascript",
	"text/ecmascript",
	"application/ecmascript",
	"module"
]);
function o(e) {
	return e.nodeName !== "#text" && e.nodeName !== "#comment" && "tagName" in e;
}
function s(e) {
	return e.nodeName === "#text";
}
function c(e, t) {
	return e.attrs.find((e) => e.name === t)?.value;
}
function l(e) {
	if (e === void 0 || e.trim() === "") return "script";
	let t = e.trim().toLowerCase();
	return t === "module" ? "module" : a.has(t) ? "script" : !1;
}
function u(e) {
	let t = [], n = null;
	for (let r of e.childNodes) s(r) && (t.push(r.value), !n && r.sourceCodeLocation && (n = r.sourceCodeLocation));
	let r = t.join("");
	if (!n) {
		let t = e.sourceCodeLocation?.startTag;
		return t ? {
			body: r,
			startLine: t.endLine,
			startColumn: t.endCol,
			startOffset: t.endOffset
		} : null;
	}
	return {
		body: r,
		startLine: n.startLine,
		startColumn: n.startCol,
		startOffset: n.startOffset
	};
}
function d(e, t) {
	o(e) && t(e);
	let n = "childNodes" in e ? e.childNodes : void 0;
	if (n) for (let e of n) d(e, t);
}
function f(e, n, r, i) {
	e.push({
		line: r,
		column: i,
		severity: "error",
		code: n,
		message: t(n)
	});
}
function p(e, n, r, i) {
	e.push({
		line: r,
		column: i,
		severity: "info",
		code: n,
		message: t(n)
	});
}
function m(e, t) {
	r(e.body, {
		positions: !0,
		line: e.startLine,
		column: e.startColumn,
		offset: e.startOffset,
		onParseError(e) {
			f(t, "css.parse", e.line, e.column);
		}
	});
}
function h(e, t, r) {
	try {
		n(e.body, {
			ecmaVersion: "latest",
			sourceType: t,
			locations: !0,
			allowReturnOutsideFunction: !1
		});
	} catch (t) {
		let n = t;
		if (!n.loc) {
			f(r, "js.syntax", e.startLine, e.startColumn);
			return;
		}
		f(r, "js.syntax", e.startLine + n.loc.line - 1, n.loc.line === 1 ? e.startColumn + n.loc.column : n.loc.column + 1);
	}
}
function g(e, t) {
	let n = c(e, "src");
	if (n === void 0 || n !== "") return;
	let r = e.sourceCodeLocation?.attrs?.src, i = r?.startLine ?? e.sourceCodeLocation?.startLine ?? 1, a = r?.startCol;
	p(t, "html.empty-src", i, a);
}
function _(t) {
	if (t.trim() === "") return {
		valid: !0,
		diagnostics: []
	};
	let n = [], r = [], a = i(t, {
		sourceCodeLocationInfo: !0,
		onParseError(e) {
			r.push(e);
		}
	});
	for (let t of r) {
		let r = e(t.code);
		r !== null && f(n, r, t.startLine, t.startCol);
	}
	return d(a, (e) => {
		if (g(e, n), e.tagName === "style") {
			let t = u(e);
			t && t.body.length > 0 && m(t, n);
			return;
		}
		if (e.tagName === "script") {
			let t = l(c(e, "type"));
			if (t === !1) return;
			let r = u(e);
			r && r.body.length > 0 && h(r, t, n);
		}
	}), {
		valid: !n.some((e) => e.severity === "error"),
		diagnostics: n
	};
}
//#endregion
export { _ as runBuiltInValidation };
